module.exports = __webpack_public_path__ + "media/images/emblems/Richterswil-acb396e86cdecded5b6291991890b5df.svg";